import type { PokerMultiTableTournaments } from '@ps/web-martech-cms-types';

import { generateMTTEffects } from '@swf/poker';

export const effects = generateMTTEffects<PokerMultiTableTournaments>();
